import { datadogRum } from "@datadog/browser-rum";
import type { ErrorComponentProps } from "@tanstack/react-router";

export function DatadogError({
  errorProps,
  render,
}: {
  errorProps: ErrorComponentProps;
  render: (props: ErrorComponentProps) => React.ReactNode;
}) {
  datadogRum.addError(errorProps.error);

  return render(errorProps);
}
